import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Marquee from "react-fast-marquee";
import ReactPlayer from "react-player";

const CustomCarousel = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const playerRef = useRef(null);

  const videoId = "jrd-acToTsE";

  useEffect(() => {
    const handleAutoplay = () => {
      const delay = data[currentIndex].time * 1000; // Convert seconds to milliseconds
      console.log(currentIndex, "delay", delay, data[currentIndex]);
      const timer = setTimeout(() => {
        if (currentIndex === data.length - 1) {
          setCurrentIndex(0);
        } else {
          setCurrentIndex(currentIndex + 1);
        }
      }, delay);

      return () => clearTimeout(timer); // Cleanup on unmount
    };

    handleAutoplay(); // Start autoplay
  }, [currentIndex, data]);

  // const handleNext = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex + 1) % data.length);
  // };

  // const handlePrev = () => {
  //   setCurrentIndex((prevIndex) => (prevIndex - 1 + data.length) % data.length);
  // };

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        bgcolor: "black",
        width: "100%",
      }}
    >
      {data.map((item, index) => (
        <div
          key={index}
          style={{
            display: index === currentIndex ? "block" : "none",
            textAlign: "center",
          }}
        >
          {item.type === "Image" ? (
            <div
              style={{
                position: "fixed", // Make it fixed to cover the full screen
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                // overflow: "hidden", // Prevent overflow
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#f0f0f0", // Optional: background color
                  padding: "10px 0", // Optional: padding
                  overflow: "hidden",
                }}
              >
                <Marquee speed={50} pauseOnHover>
                  <Typography variant="body1" component="span">
                    Cloud marketing is the process of an organization's efforts
                    to market their goods and services online through integrated
                    digital experiences, by which they are specialized for every
                    end-user
                  </Typography>
                  <Typography
                    variant="body1"
                    component="span"
                    sx={{ marginLeft: 2 }}
                  >
                    Thanks
                  </Typography>
                </Marquee>
              </Box>

              <img
                src={item.url}
                alt={`Slide ${index + 1}`}
                style={{
                  width: "80%",
                  height: "70%",
                  backgroundColor: "black",
                  objectFit: "contain",
                  overflow: "hidden",
                }}
              />
            </div>
          ) : (
            // <div>
            //   <ReactPlayer
            //     ref={playerRef}
            //     // url={item.url}
            //     url='https://www.youtube.com/watch?v=c5YdpZjW-dc'
            //     playing={true}
            //     muted={false}
            //     loop={true}
            //     controls={false}
            //     width="100%"
            //     height="auto"
            //   />
            // </div>
            <div
              style={{
                position: "fixed", // Make it fixed to cover the full screen
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                // overflow: "hidden", // Prevent overflow
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#f0f0f0", // Optional: background color
                  padding: "10px 0", // Optional: padding
                  overflow: "hidden",
                }}
              >
                <Marquee speed={50} pauseOnHover>
                  <Typography variant="body1" component="span">
                    Skycast marketing is the process of an organization's efforts
                    to market their goods and services online through integrated
                    digital experiences, by which they are specialized for every
                    end-user
                  </Typography>
                  <Typography
                    variant="body1"
                    component="span"
                    sx={{ marginLeft: 2 }}
                  >
                    Thanks
                  </Typography>
                </Marquee>
              </Box>
              {/* <iframe
                width="100%" // Set to 100% to fill the parent
                height="100%" // Set to 100% to fill the parent
                src={`https://www.youtube.com/embed/${videoId}?autoplay=1&allowfullscreen`}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe> */}
              <div>
                <ReactPlayer
                  ref={playerRef}
                  url={item.url}
                  // url={`https://www.youtube.com/embed/${videoId}?autoplay=1&allowfullscreen`}
                  playing={true}
                  muted={true}
                  loop={true}
                  controls={false}
                  width="100%"
                  height="100vh"
                />
              </div>
            </div>
          )}
        </div>
      ))}
      {/* <button onClick={handlePrev} style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)' }}>
        Prev
      </button>
      <button onClick={handleNext} style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
        Next
      </button> */}
      {/* </Card> */}
    </Box>
  );
};

export default CustomCarousel;
